import React from 'react'
import ReactMarkDown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export const MarkdownRenderer = (props: {children:string}) => {
  const { children } = props;
  return (
        <ReactMarkDown
          remarkPlugins={[remarkGfm]}
          components={{
            del: ({ children }) => (
              <del className="line-through font-texts font-normal">{children}</del>
            ),
            strong: ({ children }) => (
              <strong className="font-bold font-texts">{children}</strong>
            ),
            em: ({ children }) => (
              <em className="italic font-texts font-normal">{children}</em>
            ),
            p: ({ children }) => (
              <p className="font-normal font-texts">{children}</p>
            ),
            ul: ({ children }) => (
              <ul className="list-disc pl-5 font-normal font-texts">{children}</ul>
            ),
            ol: ({ children }) => (
              <ol className="list-decimal pl-5 font-normal font-texts">{children}</ol>
            ),
            li: ({ children }) => (
              <li className=" font-normal font-texts">{children}</li>
            ),
            a: ({ children, href }) => (
              <a href={href} className="text-info-500 hover:underline font-normal font-texts">
                {children}
              </a>
            ),
          }}
        >{children}</ReactMarkDown>
  )
}
